import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import DevicesListFilter from 'components/DevicesFilter/DevicesListFilter.js';
import LiveClock from 'components/LiveClock/LiveClock.js';
import Loading from 'components/Loading/Loading.js';
import MDTypography from 'components/MDTypography/index';
import { useEffect, useRef, useState, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { brandColors } from 'types/colors';
import { ReactComponent as Map } from '../../assets/images/icons/MAP.svg';
const DevicesCount = ({ filteredDevices, devicesType }) => {
  const [sensorsNum, setSensorsNum] = useState(0);
  const [activeSensorsNum, setActiveSensorsNum] = useState(0);

  useEffect(() => {
    setSensorsNum(filteredDevices?.length);

    let activeCount;

    if (devicesType === 'sensors') {
      activeCount = filteredDevices?.filter(
        device => device.status === 1 || device.status === 2 || device.status === 3,
      ).length;
    } else {
      activeCount = filteredDevices?.filter(device => device.status === 1).length;
    }

    setActiveSensorsNum(activeCount);
  }, [filteredDevices]);

  return (
    <Box sx={{}}>
      <Grid item>
        <Box
          sx={{
            display: 'flex',
            width: 'fit-content',
            alignItems: 'center',
          }}>
          <Typography
            sx={{ fontSize: '.85rem' }}
            color="#525252cd">{`Connected ( ${activeSensorsNum} )  |  Total ( ${sensorsNum} )`}</Typography>
        </Box>
      </Grid>
    </Box>
  );
};

export default DevicesCount;
